angular.module('cfn').directive('cfnImportSeedProperties', [
  '$rootScope',
  '$http',
  '$templateCache',
  '$compile',
  '$timeout',
  function($rootScope, $http, $templateCache, $compile, $timeout) {
    return {
      restrict: 'E',
      scope: false,
      transclude: false,
      templateUrl: require('./seed-properties.tpl.html'),
      link: function(scope, element, attr) {
        //scope is same as parents scope
        scope.$watch('details', function() {
          $timeout(function() {
            if (scope.details && scope.details.$promise) {
              scope.details.$promise.then(function() {
                scope.seedProperties = angular.fromJson(
                  scope.details.seed.sysSeed.properties
                );
              });
            }
          }, 0);
        });
      }
    };
  }
]);
